<template>
  <div>
    <b-row class="justify-content-md-center">
      <b-col class="mt-5" col lg="6">
        <b-form @submit="onSubmit" v-if="show">
          <b-form-group
            id="group1"
            class="text-left mt-1"
            :label="$t('recover_pass_confirm.password_label')"
            :invalid-feedback="form_invalid_feedback.new_password"
            label-for="passinput"
          >
            <b-form-input
              id="passinput"
              v-model="form.new_password"
              type="password"
              :state="form_state.new_password"
              required
              :placeholder="$t('recover_pass_confirm.password_placeholder')"
              @focus="handleOnFocusPassInput()"
            >
            </b-form-input>
            <PasswordHelper
              :password="form.new_password"
              :show="show_pass_helper"
            />
          </b-form-group>

          <b-form-group
            id="group2"
            class="text-left  pt-3"
            :label="$t('recover_pass_confirm.password_retype_label')"
            :invalid-feedback="form_invalid_feedback.password_retype"
            label-for="passinput"
          >
            <b-form-input
              id="passinput_retype"
              v-model="form.password_retype"
              type="password"
              :state="form_state.password_retype"
              required
              :placeholder="$t('recover_pass_confirm.password_retype_placeholder')"
            >
            </b-form-input>
          </b-form-group>

          <b-row class="text-left mt-5" no-gutters>
            <b-col cols="12" md="6">
              <b-button
                type="submit"
                size="xl"
                variant="primary-b"
              >{{ $t('recover_pass_confirm.submit_button') }}</b-button>
            </b-col>
          </b-row>
        </b-form>
        <b-row class="text-left mt-4">
          <b-col cols="12" md="6">
            <router-link :to="{name: 'login'}">{{ $t('recover_pass_confirm.back_to_login') }}</router-link>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>


<script>
import PasswordHelper from "@/components/PasswordHelper";

export default {
  name: "recover-pass",
  components: {
    PasswordHelper,
  },
  data() {
    return {
      show_pass_helper: false,
      form: {
        new_password: "",
        password_retype: "",
      },
      form_invalid_feedback: {
        new_password: undefined,
        password_retype: undefined,
      },
      form_state: {
        new_password: undefined,
        password_retype: undefined,
      },
      show: true,
    };
  },
  fallbackI18n: {
    messages: {
      und: {
        recover_pass_confirm: {
          password_placeholder: "Enter password",
          password_label: "New Password",
          password_retype_placeholder: "Retype password",
          pass_not_match: "Password does not match.",
          password_retype_label: "Retype password",
          submit_button: "Recover pass",
          back_to_login: "Back to login",
        },
      },
    },
  },
  methods: {
    handleOnFocusPassInput() {
      this.show_pass_helper = true;
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.cleanFormErrors();
      if (this.form.new_password != this.form.password_retype) {
        this.putFormFeedback({
          data: {
            password_retype: this.$t("recover_pass_confirm.pass_not_match"),
          },
        });
        return;
      }

      var data = {
        uid: this.$route.params.uid,
        token: this.$route.params.token,
        new_password: this.form.new_password,
      };

      this.$store.dispatch("auth/RECOVER_PASS_CONFIRM", data).then(
        response => {
          this.$emit("pass:recovered:success", {
            state: true,
            response: response,
          });
        },
        err => {
          this.$emit("pass:recovered:error", {
            state: false,
            response: err.response,
          });
          this.showResponseError(err.response);
          this.putFormFeedback(err.response);
        }
      );
    },
  },
};
</script>


<style lang="scss" scoped>
</style>
